import { Row } from "antd";
import React from "react";
import { useState } from "react";
import Adjuntar from "../../Img/Iconos/AdjuntarArchivo.svg";
import deleteIcon from "../../Img/Iconos/eliminar.svg";
import Icono from "../IconosDeSitio";
import { OndemandVideo } from "@mui/icons-material";
import { FileWordOutlined } from "@ant-design/icons";
import PreviewImage from "./previewImage";

export default function InputFileListGeneric({ extras, formats, valueArrayImg, handleDeleteFile, handleUploadfile }) {
  const [OpenArchivo, setOpenArchivo] = useState(1);
  const [TotalMegas, setTotalMegas] = useState(0);

  function addImagesToArray(e) {
    let array_files = e.currentTarget.files;
    let total_temp = 0;

    Object.keys(e.currentTarget.files).forEach(x => {
      total_temp += array_files[x].size;
    });

    if (total_temp <= 20000000) {
      const arrayImages = [];

      Object.keys(array_files).forEach((i) => {
        const file = array_files[i];
        let url = URL.createObjectURL(file);
        let formato = file.type.split("/");

        let fileSize = ((file.size / 1024) / 1024);
        if (formato[1] === "pdf" || formato[1] === "jpeg" || formato[1] === "png" || formato[1] === "doc" || formato[1] === "docx"
          || formato[1] === "msword" || formato[1] === "vnd.openxmlformats-officedocument.wordprocessingml.document" || formato[1] === "jpg") {
            if (fileSize <= 6) {
              arrayImages.push({
                name: file.name,
                url,
                file,
                size: file.size,
                formato: formato[1],
                tipo: "0",
              });

              if (extras[3] !== undefined) {
                extras[3](arrayImages);
              }

              let total = TotalMegas + fileSize;
              setTotalMegas(total);
            } else {
              if (extras !== undefined) {
                extras[0](true);
                extras[1]("warning");
                extras[2]("El archivo excede el tamaño maximo permitido (6MB)");
              }
            }

        } else {
          if (formato[0] === "video") {
            if (fileSize <= 10) {
              arrayImages.push({
                name: file.name,
                url,
                file,
                size: file.size,
                formato: formato[1],
                tipo: "0",
              });

              if (extras[3] !== undefined) {
                extras[3](arrayImages);
              }

              let total = TotalMegas + fileSize;
              setTotalMegas(total);
            } else {
              if (extras !== undefined) {
                extras[0](true);
                extras[1]("warning");
                extras[2]("El video excede el tamaño maximo permitido (10MB)");
              }
            }
          } else {

            extras[0](true);
            extras[1]("warning");
            if (formats === 1) {
              extras[2]("Tipo de archivo no valido. Archivos permitidos: imagenes ( png, jpeg )");
            } else if (formats === 2) {
              extras[2]("Tipo de archivo no valido. Archivos permitidos: videos");
            } else if (formats === 3) {
              extras[2]("Tipo de archivo no valido. Archivos permitidos: archivos (pdf)");
            } else if (formats === 4) {
              extras[2]("Tipo de archivo no valido. Archivos permitidos: imagenes y archivos ( png, jpeg, pdf )");
            } else if (formats === 5 || formats === undefined) {
              extras[2]("Tipo de archivo no valido. Archivos permitidos: imagenes, archivos y videos ( png, jpeg, pdf, doc, docx )");
            }
          }
        }
      });
      if (arrayImages.length > 0) {
        handleUploadfile(arrayImages);
      }
    } else {
      extras[0](true);
      extras[1]("warning");
      extras[2]("El listado de archivos excede el tamaño maximo permitido (20MB)");
    }
    document.getElementById("FileArchivoList").value = "";
  }

  function selectFormato() {
    const Imagenes = {
      input: "image/png,image/jpeg",
      validacion: ["png", "jpeg"]
    };
    const Videos = {
      input: "video/*",
      validacion: []
    };
    const Pdf = {
      input: "application/pdf",
      validacion: ["pdf"]
    };
    const Archivos = {
      input: "image/png,image/jpeg,application/pdf",
      validacion: ["png", "jpeg", "pdf"]
    }
    const Todos = {
      input: ".doc,.docx,image/png,image/jpeg,application/pdf,video/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      validacion: ["png", "jpeg", "pdf", "doc", "docx", "msword", "vnd.openxmlformats-officedocument.wordprocessingml.document"]
    }

    if (formats === 1) {
      return Imagenes.input;
    } else if (formats === 2) {
      return Videos.input;
    } else if (formats === 3) {
      return Pdf.input;
    } else if (formats === 4) {
      return Archivos.input;
    } else if (formats === 5 || formats === undefined) {
      return Todos.input;
    }
  }

  return (
    <>
      <label htmlFor="FileArchivoList" style={{ cursor: "pointer", display: 'flex', justifyContent: 'center' }}>
        <img style={{ width: "16px" }} src={Adjuntar} alt="" />
        <b>Adjuntar</b>
        <input
          hidden={true}
          id="FileArchivoList"
          type="file"
          accept={`${selectFormato}`}
          onChange={(e)=>addImagesToArray(e)}
          style={{ display: "none" }}
          multiple
        />
      </label>
      <br />
      <br />
      {OpenArchivo === 0 ? (
        <div>
          <p>Aun no se agregan archivos</p>
        </div>
      ) : (
        <div>
          {OpenArchivo === 1 &&
            valueArrayImg.map((file, index) => (
              <Row style={{ justifyContent: "space-between", padding: "1% 3%", border: "1px solid #d7d7d7", margin: "10px 0" }} key={index}>
                {
                  (file.formato === "png" || file.formato === "jpeg" || file.formato === "jpg") ?
                    (
                      <Row
                        style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: "90%" }}

                      >
                        <PreviewImage urlImage={file.url} style={{ width: "30px", height: "30px" }} imageName={file.name} />
                        <div onClick={() => { window.open(file.url, "_blank") }} style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                          <span>{file.name}</span>
                        </div>
                        <div >
                          {!!file.size && `${(file.size / 1000000).toFixed(2)} MB`}
                        </div>
                      </Row>
                    ) : file.formato === "pdf" ?
                      (
                        <Row
                          style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: "90%" }}
                          onClick={() => { window.open(file.url, "_blank") }}
                        >
                          <img style={{ width: "5%", marginRight: "3px" }} src={Icono[22]} alt="" />
                          <div style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                            <span>{file.name}</span>
                          </div>
                          <div>
                            {!!file.size && `${(file.size / 1000000).toFixed(2)} MB`}
                          </div>
                        </Row>
                      ) : (file.formato === "doc" || file.formato === "docx" || file.formato === "msword" || file.formato === "vnd.openxmlformats-officedocument.wordprocessingml.document") ? (
                        <Row
                          style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: "90%" }}
                          onClick={() => { window.open(file.url, "_blank") }}
                        >
                          <FileWordOutlined style={{ fontSize: "250%", color: "#148F9F" }} />
                          <div style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                            <span>{file.name}</span>
                          </div>
                          <div>
                            {!!file.size && `${(file.size / 1000000).toFixed(2)} MB`}
                          </div>
                        </Row>
                      ) :
                        (
                          <Row
                            style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: "90%" }}
                            onClick={() => { window.open(file.url, "_blank") }}
                          >
                            <OndemandVideo sx={{ color: "#148F9F" }} />
                            <div style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                              <span>{file.name}</span>
                            </div>
                            <div>
                              {!!file.size && `${(file.size / 1000000).toFixed(2)} MB`}
                            </div>
                          </Row>
                        )
                }
                <img
                  style={{ width: "18px", cursor: "pointer" }}
                  onClick={()=> handleDeleteFile(file.id)}
                  src={deleteIcon}
                  alt=""
                />
              </Row>
            ))}
        </div>
      )}

    </>
  );
}
